import { useCallback } from 'react';

import { IRestaurantNode } from 'generated/rbi-graphql';
import { usePosDataQuery } from 'state/store/hooks/use-pos-data-query';

type UseStoreLocatorPrefetchHook = () => {
  prefetchRestaurantValuesForOrder: (restaurant: IRestaurantNode) => void;
};

export const useStoreLocatorPrefetch: UseStoreLocatorPrefetchHook = () => {
  const { refetch: getPosData } = usePosDataQuery({
    lazy: true,
    restaurantPosDataId: '',
    storeNumber: '',
  });

  const prefetchRestaurantValuesForOrder = useCallback(
    (restaurant: IRestaurantNode) => {
      getPosData({
        restaurantPosDataId: restaurant.restaurantPosData?._id || '',
        storeNumber: restaurant.number || null,
      });
    },
    [getPosData]
  );

  return {
    prefetchRestaurantValuesForOrder,
  };
};
